export class CheckboxItem<T> {
  value: T;
  label: string;
  checked: boolean;

  constructor(value: T, label: any, checked?: boolean) {
    this.value = value;
    this.label = label;
    this.checked = checked ? checked : false;
  }
}
